export const formatCpfCnpj = (value) => {
  const numbers = value.replace(/\D/g, '')
  
  if (numbers.length <= 11) {
    return numbers
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1')
  } else {
    return numbers
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1')
  }
}

// Remove o DDI 55 pra exibir só (DDD) + número no formulário
export const stripDDI = (value) => {
  const numbers = (value || '').replace(/\D/g, '')
  if (numbers.length >= 12 && numbers.startsWith('55')) {
    return numbers.slice(2)
  }
  return numbers
}

// Garante o DDI 55 na frente pra salvar/enviar pro WhatsApp (Uazapi espera 55DDDNUMERO)
export const addDDI = (value) => {
  const numbers = (value || '').replace(/\D/g, '')
  if (!numbers) return ''
  if (numbers.startsWith('55') && numbers.length >= 12) {
    return numbers
  }
  return `55${numbers}`
}

export const formatPhone = (value) => {
  const numbers = value.replace(/\D/g, '')
  
  if (numbers.length <= 10) {
    return numbers
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1')
  } else {
    return numbers
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1')
  }
}

export const formatCep = (value) => {
  const numbers = value.replace(/\D/g, '')
  return numbers
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1')
}